import checkStatus from "../../../helpers/checkStatus"
import cleanObject from "../../../helpers/cleanObject"
import * as http from "./http"

export const EVENT_CREATED = "EVENT_CREATED"
export const EVENT_ADDED_ROOM = "EVENT_ADDED_ROOM"
export const EVENT_REMOVED_ROOM = "EVENT_REMOVED_ROOM"

export function eventAdd(event) {
  cleanObject(event)
  return dispatch => http.eventAdd(event)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_CREATED",
        payload: res
      })
      return res
    })
}

export function eventAddRoom(event_id, room_id) {
  return dispatch => http.eventAddRoom(event_id, room_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: EVENT_ADDED_ROOM,
        payload: res
      })
      return res
    })
}

export function eventRemoveRoom(event_id, room_id) {
  return dispatch => http.eventRemoveRoom(event_id, room_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: EVENT_REMOVED_ROOM,
        payload: res
      })
      return res
    })
}

export function eventGetAll() {
  return dispatch => http.eventGetAll()
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENTS_FETCHED",
        payload: {
          events: res.data
        }
      })
      return res
    })
}

export function eventGetOne(_id) {
  return dispatch => http.eventGetOne(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_FETCHED",
        payload: res.data
      })
    })
}

export function eventUpdate(_id, event) {
  cleanObject(event)
  console.log(event)
  return dispatch => http.eventUpdate(_id, event)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_UPDATED"
      })
      return res
    })
}

export function eventUpdateEmailContent(_id, event) {
  cleanObject(event)
  return dispatch => http.eventUpdateEmailContent(_id, event)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_EMAIL_UPDATED",
        payload: res.data
      })
      return res
    })
}

export function eventUpdateModeratorEmailContent(_id, event) {
  cleanObject(event)
  return dispatch => http.eventUpdateModeratorEmailContent(_id, event)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_EMAIL_UPDATED",
        payload: res.data
      })
      return res
    })
}

export function eventDelete(_id) {
  return dispatch => http.eventDelete(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch(eventGetAll())
      return res
    })
}

export function eventClone(_id) {
  return dispatch => http.eventClone(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch(eventGetAll())
      return res
    })
}

export function eventSendEmail(_id, speakerIDs, emailObject) {
  return dispatch => http.eventSendEmail(_id, speakerIDs, emailObject)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then(() => {
      dispatch({
        type: "EVENT_EMAIL_SENT"
      })
    })
}

export function eventSendModeratorEmail(_id, speakerIDs, emailObject) {
  return dispatch => http.eventSendModeratorEmail(_id, speakerIDs, emailObject)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then(() => {
      dispatch({
        type: "EVENT_EMAIL_SENT"
      })
    })
}

export function eventGetOneAsPublic(_id) {
  return dispatch => http.eventGetOneAsPublic(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_FETCHED",
        payload: {
          event: res.data
        }
      })
    })
}

export function publicEventGetOne(eventId, presentationId) {
  const fetchString = `${eventId}${presentationId ? `/${presentationId}` : ""}`
  return dispatch => http.publicEventGetOne(fetchString)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_PRESENTATIONS_FETCHED",
        payload: {
          data: res.data
        }
      })
      return res
    })
}

export function passwordEventGetOne(eventId, password, presentationId) {
  const fetchString = `${eventId}/${password}${presentationId ? `/${presentationId}` : ""}`
  return dispatch => http.passwordEventGetOne(fetchString)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_PRESENTATIONS_FETCHED",
        payload: {
          data: res.data
        }
      })
    })
}

export function getSpeakerPresentations(eventId, speakerId) {
  return dispatch => http.getSpeakerPresentations(eventId, speakerId)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENT_PRESENTATIONS_FETCHED",
        payload: {
          data: res.data
        }
      })
      return res
    })
}

export function getAllPublicEvents() {
  return dispatch => http.getAllPublicEvents()
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "EVENTS_FETCHED",
        payload: {
          events: res.data
        }
      })
      return res
    })
}
